angular.module('cn')
.component('accountEdit', {
  template: require('./accountedit.html'),
  bindings: {
    node: '<',
    callback: '&'
  },
  controller: [
    '$timeout',
    'accountsRepository',
    function($timeout, accountsRepository) {
      var $ctrl = this;
      var backup;
      this.$onInit = function() {
        $ctrl.accounts = [];
        backup = $ctrl.node;
        accountsRepository.getAll().then(function(accounts) {
          $ctrl.accounts = accounts;
        });
      };

      this.onSelect = function(item, model) {
        $ctrl.onSelectFired = true;
        $ctrl.callback({
          data: model
        });
      };

      this.clear = function() {
        // trigger the ng-blur ONLY IF the uib-typeahead-on-select wasn't trigger
        // I must use a timeout because ng-blur it's trigger BEFORE uib-typeahead-on-select
        $timeout(function() {
          if (!$ctrl.onSelectFired) {
            $ctrl.callback({});
          }
        }, 300);
      };
    }
  ]
});



// WEBPACK FOOTER //
// ./src/cn/accountedit.js